module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "largeheight1rr"
  }, [_vm._v("Avertissement")]), _vm._v(" "), _c('p', {
    staticClass: "center1rr"
  }, [_vm._v("Ce fichier ePub a été conçu par les Éditions Scholastic. Des problèmes d’affichage pourraient se produire lors de la lecture. Les Éditions Scholastic s’excusent de ces éventuels inconvénients, indépendants de leur volonté.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493fb0e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/fm1.vue
// module id = 69
// module chunks = 0